import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ProjectCard } from "./ProjectCard";
import { Info } from "lucide-react";

export const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .listProjects()
      .then(setProjects)
      .catch(() => setProjects([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section id="projects" data-testid="projects-section" className="py-24 md:py-32 border-t border-black/5">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="overline text-primary mb-4">Selected Work</p>
            <h2 className="font-serif text-3xl md:text-5xl text-foreground max-w-2xl leading-tight">
              Case studies in strategy, systems, and craft.
            </h2>
          </div>
          <div className="flex items-start gap-2 text-sm text-foreground/50 max-w-xs">
            <Info size={16} className="mt-0.5 shrink-0" />
            <span>Some work is anonymized or simplified due to client confidentiality.</span>
          </div>
        </div>

        {loading ? (
          <div className="grid md:grid-cols-2 gap-8">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="aspect-[16/11] rounded-2xl bg-secondary animate-pulse" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-testid="projects-grid">
            {projects.map((p, i) => (
              <ProjectCard key={p.id} project={p} large index={i} />
            ))}
          </div>
        )}

        {!loading && projects.length === 0 && (
          <p className="text-foreground/50">No projects yet.</p>
        )}
      </div>
    </section>
  );
};
